// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voicemail-templates-tab {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.vt-category-desc {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: #666;
}

/* Category filter pills */
.vt-category-bar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.vt-category-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid var(--color-border);
  border-radius: 20px;
  background: var(--wellsky-white);
  color: #555;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.vt-category-pill:hover {
  border-color: var(--wellsky-blue);
  color: var(--wellsky-blue);
}

.vt-category-pill.active {
  background: var(--wellsky-indigo);
  border-color: var(--wellsky-indigo);
  color: white;
}

.vt-pill-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 5px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
}

.vt-category-pill.active .vt-pill-count {
  background: rgba(255, 255, 255, 0.25);
}

.tab-header h2 {
  margin: 0;
}

.btn-add {
  padding: 8px 16px;
  background: var(--wellsky-blue);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
}

.btn-add:hover {
  background: #5a9a9e;
}

/* Messages */
.vt-error {
  background: #fde8e8;
  color: #c53030;
  padding: 10px 14px;
  border-radius: 4px;
  border-left: 4px solid #c53030;
  font-size: 14px;
}

.vt-success {
  background: #e6ffed;
  color: #22543d;
  padding: 10px 14px;
  border-radius: 4px;
  border-left: 4px solid #28a745;
  font-size: 14px;
}

/* Form Card */
.vt-form-card {
  background: var(--wellsky-white);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.vt-form-card h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
  color: var(--wellsky-indigo);
}

.vt-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.vt-field-wide {
  grid-column: 1 / -1;
}

.vt-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
  color: var(--wellsky-indigo);
}

.field-hint {
  font-weight: 400;
  color: #888;
  font-size: 12px;
}

.vt-field input[type="text"],
.vt-field input[type="number"],
.vt-field select,
.vt-field textarea {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  background: var(--wellsky-white);
  box-sizing: border-box;
}

.vt-field textarea {
  resize: vertical;
}

.vt-field input:focus,
.vt-field select:focus,
.vt-field textarea:focus {
  outline: none;
  border-color: var(--wellsky-blue);
  box-shadow: 0 0 0 2px rgba(113, 176, 180, 0.25);
}

.vt-field input:disabled,
.vt-field select:disabled {
  background: #f5f5f5;
  color: #888;
  cursor: not-allowed;
}

.checkbox-label {
  display: flex !important;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: auto;
}

.vt-form-actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--color-border);
}

.btn-save {
  padding: 8px 20px;
  background: var(--wellsky-blue);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
}

.btn-save:hover:not(:disabled) {
  background: #5a9a9e;
}

.btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-cancel {
  padding: 8px 20px;
  background: none;
  color: #666;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.btn-cancel:hover {
  background: #f5f5f5;
}

/* Table */
.vt-table-wrapper {
  background: var(--wellsky-white);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  overflow-x: auto;
}

.vt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.vt-table thead {
  background: var(--wellsky-indigo);
  color: white;
}

.vt-table th {
  padding: 10px 14px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
}

.vt-table td {
  padding: 10px 14px;
  border-bottom: 1px solid #eee;
  vertical-align: top;
}

.vt-table tbody tr:hover {
  background: #f8f9fa;
}

.vt-table tbody tr.vt-inactive {
  opacity: 0.5;
}

.vt-key {
  font-family: monospace;
  font-size: 13px;
  color: var(--wellsky-indigo);
  font-weight: 600;
}

.vt-message {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #555;
}

.vt-empty {
  text-align: center;
  color: #888;
  padding: 30px 14px !important;
}

.vt-status {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
}

.vt-status.active {
  background: #e6ffed;
  color: #22543d;
}

.vt-status.inactive {
  background: #fde8e8;
  color: #c53030;
}

.placeholder-help {
  background: #f0f7ff;
  border: 1px solid #bdd7ee;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 13px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  color: #444;
}

.placeholder-help code {
  background: #e2ecf5;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 13px;
  color: var(--wellsky-indigo);
}

.vt-actions {
  white-space: nowrap;
  display: flex;
  gap: 6px;
}

.btn-edit {
  padding: 4px 10px;
  background: var(--wellsky-blue);
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
}

.btn-edit:hover {
  background: #5a9a9e;
}

.btn-deactivate {
  padding: 4px 10px;
  background: none;
  color: #c53030;
  border: 1px solid #c53030;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
}

.btn-deactivate:hover {
  background: #fde8e8;
}

@media (max-width: 768px) {
  .vt-form-grid {
    grid-template-columns: 1fr;
  }

  .tab-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .vt-message {
    max-width: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/tabs/VoicemailTemplatesTab.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".voicemail-templates-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.tab-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.vt-category-desc {\n  margin: 4px 0 0 0;\n  font-size: 13px;\n  color: #666;\n}\n\n/* Category filter pills */\n.vt-category-bar {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.vt-category-pill {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border: 1px solid var(--color-border);\n  border-radius: 20px;\n  background: var(--wellsky-white);\n  color: #555;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.vt-category-pill:hover {\n  border-color: var(--wellsky-blue);\n  color: var(--wellsky-blue);\n}\n\n.vt-category-pill.active {\n  background: var(--wellsky-indigo);\n  border-color: var(--wellsky-indigo);\n  color: white;\n}\n\n.vt-pill-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 18px;\n  padding: 0 5px;\n  background: rgba(0, 0, 0, 0.12);\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.vt-category-pill.active .vt-pill-count {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.tab-header h2 {\n  margin: 0;\n}\n\n.btn-add {\n  padding: 8px 16px;\n  background: var(--wellsky-blue);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.btn-add:hover {\n  background: #5a9a9e;\n}\n\n/* Messages */\n.vt-error {\n  background: #fde8e8;\n  color: #c53030;\n  padding: 10px 14px;\n  border-radius: 4px;\n  border-left: 4px solid #c53030;\n  font-size: 14px;\n}\n\n.vt-success {\n  background: #e6ffed;\n  color: #22543d;\n  padding: 10px 14px;\n  border-radius: 4px;\n  border-left: 4px solid #28a745;\n  font-size: 14px;\n}\n\n/* Form Card */\n.vt-form-card {\n  background: var(--wellsky-white);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.vt-form-card h3 {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  color: var(--wellsky-indigo);\n}\n\n.vt-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.vt-field-wide {\n  grid-column: 1 / -1;\n}\n\n.vt-field label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: var(--wellsky-indigo);\n}\n\n.field-hint {\n  font-weight: 400;\n  color: #888;\n  font-size: 12px;\n}\n\n.vt-field input[type=\"text\"],\n.vt-field input[type=\"number\"],\n.vt-field select,\n.vt-field textarea {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  background: var(--wellsky-white);\n  box-sizing: border-box;\n}\n\n.vt-field textarea {\n  resize: vertical;\n}\n\n.vt-field input:focus,\n.vt-field select:focus,\n.vt-field textarea:focus {\n  outline: none;\n  border-color: var(--wellsky-blue);\n  box-shadow: 0 0 0 2px rgba(113, 176, 180, 0.25);\n}\n\n.vt-field input:disabled,\n.vt-field select:disabled {\n  background: #f5f5f5;\n  color: #888;\n  cursor: not-allowed;\n}\n\n.checkbox-label {\n  display: flex !important;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: auto;\n}\n\n.vt-form-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid var(--color-border);\n}\n\n.btn-save {\n  padding: 8px 20px;\n  background: var(--wellsky-blue);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.btn-save:hover:not(:disabled) {\n  background: #5a9a9e;\n}\n\n.btn-save:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-cancel {\n  padding: 8px 20px;\n  background: none;\n  color: #666;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-cancel:hover {\n  background: #f5f5f5;\n}\n\n/* Table */\n.vt-table-wrapper {\n  background: var(--wellsky-white);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  overflow-x: auto;\n}\n\n.vt-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.vt-table thead {\n  background: var(--wellsky-indigo);\n  color: white;\n}\n\n.vt-table th {\n  padding: 10px 14px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.vt-table td {\n  padding: 10px 14px;\n  border-bottom: 1px solid #eee;\n  vertical-align: top;\n}\n\n.vt-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.vt-table tbody tr.vt-inactive {\n  opacity: 0.5;\n}\n\n.vt-key {\n  font-family: monospace;\n  font-size: 13px;\n  color: var(--wellsky-indigo);\n  font-weight: 600;\n}\n\n.vt-message {\n  max-width: 400px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #555;\n}\n\n.vt-empty {\n  text-align: center;\n  color: #888;\n  padding: 30px 14px !important;\n}\n\n.vt-status {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.vt-status.active {\n  background: #e6ffed;\n  color: #22543d;\n}\n\n.vt-status.inactive {\n  background: #fde8e8;\n  color: #c53030;\n}\n\n.placeholder-help {\n  background: #f0f7ff;\n  border: 1px solid #bdd7ee;\n  border-radius: 4px;\n  padding: 10px 14px;\n  font-size: 13px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  color: #444;\n}\n\n.placeholder-help code {\n  background: #e2ecf5;\n  padding: 2px 8px;\n  border-radius: 3px;\n  font-size: 13px;\n  color: var(--wellsky-indigo);\n}\n\n.vt-actions {\n  white-space: nowrap;\n  display: flex;\n  gap: 6px;\n}\n\n.btn-edit {\n  padding: 4px 10px;\n  background: var(--wellsky-blue);\n  color: white;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.btn-edit:hover {\n  background: #5a9a9e;\n}\n\n.btn-deactivate {\n  padding: 4px 10px;\n  background: none;\n  color: #c53030;\n  border: 1px solid #c53030;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.btn-deactivate:hover {\n  background: #fde8e8;\n}\n\n@media (max-width: 768px) {\n  .vt-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .tab-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .vt-message {\n    max-width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
